import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'

import { Flex, Grid, Box } from '@chatterbug/aaron'

const MyCourseHeaderSkeleton = ({
  nameSection,
  cefrLevelSection,
  actionsSection,
  theme,
}) => {
  return (
    <Grid gridGap="1x" gridTemplateColumns="auto auto" alignItems="center">
      <Flex
        gridColumn={{ _: '1 / span 2', tablet: '1 / span 1' }}
        alignItems="center"
        justifyContent={{ _: 'space-between', tablet: 'flex-start' }}
      >
        <Box mr="2x">{nameSection}</Box>
        {cefrLevelSection}
      </Flex>

      {actionsSection && (
        <Flex
          minHeight={36} // to toggle between links and buttons
          justifyContent={{ _: 'flex-start', tablet: 'flex-end' }}
          alignItems="center"
          ml={{ _: `-${theme.space['1x']}`, tablet: 0 }} // to offset for the padding on action buttons on mobile and align it with "My Course"
          gridColumn={{ _: '1 / span 1', tablet: '2 / span 1' }}
        >
          {actionsSection}
        </Flex>
      )}
    </Grid>
  )
}

MyCourseHeaderSkeleton.propTypes = {
  nameSection: PropTypes.any.isRequired,
  cefrLevelSection: PropTypes.any,
  actionsSection: PropTypes.any,
}

export default withTheme(MyCourseHeaderSkeleton)
